import { render } from "./ExplainView.vue?vue&type=template&id=6777499e&scoped=true"
import script from "./ExplainView.vue?vue&type=script&lang=js"
export * from "./ExplainView.vue?vue&type=script&lang=js"

import "./ExplainView.vue?vue&type=style&index=0&id=6777499e&scoped=true&lang=css"

import exportComponent from "/root/workspace/web--ming-pan_4MVO/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6777499e"]])

export default __exports__